export default {
  ECodeOptionsType: {
    Folder: 1,
    DocumentType: 2,
    Sequence: 3,
    RevisionNumber: 4,
    RevisionYear: 5,
    Extension: 6,
  },
};
